
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.921 6.95L4.622.3A2.849 2.849 0 00.746 4.005l2.28 5.103a1.008 1.008 0 010 .779L.746 14.99A2.851 2.851 0 003.35 19a2.98 2.98 0 001.283-.304l13.299-6.652a2.85 2.85 0 000-5.093h-.01zm-.845 3.393l-13.3 6.652a.95.95 0 01-1.282-1.235l2.27-5.103c.03-.069.055-.138.077-.21h6.545a.95.95 0 100-1.9H4.84a1.902 1.902 0 00-.076-.21l-2.27-5.102A.95.95 0 013.776 2l13.299 6.652a.95.95 0 010 1.691z","fill":"#748190"}})])
          )
        }
      }
    